import React from 'react';

import Script from 'next/script';

const KlaviyoEmbed: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <>
      <Script src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=RcYWM2" />
      <div className="klaviyo-form-YwHQMe" />
    </>
  );
};

export default KlaviyoEmbed;
